exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.user-profile{display:flex;flex-direction:column;align-items:center;font-family:Open Sans,sans-serif;height:100%}.user-profile .user-avatar{margin-right:0;margin-top:32px}.user-profile__name{margin:32px 0 16px;text-transform:uppercase;font-size:24px;line-height:24px;max-height:48px;overflow:hidden;text-align:center}.user-profile__divider{border-top:1px solid;width:32px}.user-profile__contact-info{margin-left:72px;width:calc(100% - 72px);margin-top:16px}.user-profile__contact-info img{width:16px;margin-right:8px}.user-profile__contact-info .email,.user-profile__contact-info .phone,.user-profile__contact-info .sms{display:flex;height:24px;line-height:24px;font-size:12px;margin-bottom:6px}.user-profile__contact-info .email p,.user-profile__contact-info .phone p,.user-profile__contact-info .sms p{margin:0}.user-profile__contact-info .email p{max-width:calc(100% - 32px);max-height:24px;line-height:12px;overflow:hidden;word-break:break-all}.user-profile__logout{border-radius:4px;background-color:#184e78;border:1px solid #184e78}.user-profile__logout,.user-profile__logout-badconnection{position:absolute;bottom:0;font-size:14px;font-weight:600;height:32px;width:116px;cursor:pointer;outline:none;color:#fff;margin-bottom:24px}.user-profile__logout-badconnection{border-radius:4px;background-color:#e0e0e0;border:1px solid #e0e0e0}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/MobileUserProfile/MobileUserProfile.scss
// module id = 1753
// module chunks = 0